import { SlimAuctionsEntity } from 'libs/gb-dashboard/auctions/data-access/src/lib/+state/auctions.models'
import { AuctionsEntity } from 'libs/gb-dashboard/auctions/data-access-selected-auction/src/lib/+state/selected-auction.models'

export function isAuctionHidden(auction: SlimAuctionsEntity | AuctionsEntity | null | undefined): boolean {
  return !!auction?.archive_hide_date && Date.now() >= new Date(auction.archive_hide_date).getTime()
}
